// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"357":"d92a0c31","480":"d92a0c31","689":"95ec61cf","778":"57016fc6","828":"81c83828"}[chunkId] + ".chunk.css";
};